import {
    GETALLTRANSACTION,
    CREATETRANSACTION,
    UPDATEALLTRANSACTION,
    DELETEALLTRANSACTION,
    CREATECHEQUE,
    axios,
    baseURL,
  } from "./types";
  

  export const getAllTransaction = (data) => async (dispatch) => {
    console.log("getAllTransaction action called with:", data);
    var config = {
      method: "post",
      url: baseURL + "/api/setuptransactions/getall",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    try {
      const response = await axios(config);
      return dispatch({
        type: GETALLTRANSACTION,
        payload: response.data,
      });
    } catch (error) {
      console.log("Error in getAllTransaction action:", error);
    }
};
  
  export const createTransaction = (data) => (dispatch) => {
    var config = {
      method: "post",
      url: baseURL + "/api/setuptransactions/create",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data:data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: CREATETRANSACTION,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  export const updateTransaction = (data) => (dispatch) => {
    var config = {
      method: "patch",
      url: baseURL + "/api/setuptransactions/update",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: UPDATEALLTRANSACTION,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const deleteTransaction = (data) => (dispatch) => {
    var config = {
      method: "delete",
      url: baseURL + "/api/setuptransactions/delete",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: DELETEALLTRANSACTION,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const createCheque = (data) => (dispatch) => {
    var config = {
      method: "post",
      url: baseURL + "/api/setupcheque/create",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data:data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: CREATECHEQUE,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };